import {SOPostEntityPermission} from '../../core/entity-permission/so-post-entity-permission';
import {EntityPermissionCore} from './entity-permission.core';
import {SOGetEntityPermission} from '../../core/entity-permission/so-get-entity-permission';
import {FormField, SelectionOption} from 'lionheartland';
import {postEntityPermissionFormFieldOptions} from './post-entity-permission-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {EntityCore} from '../entity/entity.core';
import {SOGetEntity} from '../../core/entity/so-get-entity';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostEntityPermission extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postEntityPermissionFormFieldOptions);

  RequestClass = SOPostEntityPermission

  constructor(
    public entityCore: EntityPermissionCore
  ) {
    super();
    if (postEntityPermissionFormFieldOptions.entity) {
      postEntityPermissionFormFieldOptions.entity.makeCore = true;
    }
    if (postEntityPermissionFormFieldOptions.project) {
      postEntityPermissionFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('whiteList'),
      this.getFormValueFromIdentifier('permissionType'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'entity',
        SOGetEntity,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}